<script setup lang="ts">
import ChatSessionPane from "@/client/components/ChatSessionPane.vue";
</script>
<template><ChatSessionPane /></template>
